module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "lot"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0006#toc"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#th0201a"
    }
  }, [_vm._v("2.1a")]), _vm._v("  Change in Democratic Party affect as a function of change in Democratic candidate affect")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#th0201b"
    }
  }, [_vm._v("2.1b")]), _vm._v("  Change in Republican Party affect as a function of change in Republican candidate affect")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#th0202"
    }
  }, [_vm._v("2.2")]), _vm._v("  Coefficients from regressions of party affect on candidate affect over the 2008 election year")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0301"
    }
  }, [_vm._v("3.1")]), _vm._v("  Approval of the president’s job performance and favorable views of president’s party")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0302"
    }
  }, [_vm._v("3.2")]), _vm._v("  Positive views of the president and positive views of president’s party")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0303"
    }
  }, [_vm._v("3.3")]), _vm._v("  Consistent positive or negative opinions of the president and his party (percent)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0304"
    }
  }, [_vm._v("3.4")]), _vm._v("  Consistent approval/disapproval of president’s performance and favorable/unfavorable opinions of his party (percent)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0305"
    }
  }, [_vm._v("3.5")]), _vm._v("  Favorable opinion of opposition party as a function of presidential approval")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0306"
    }
  }, [_vm._v("3.6")]), _vm._v("  Positive views of the president and the opposition party")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0307"
    }
  }, [_vm._v("3.7")]), _vm._v("  Approval of the president’s job performance and approval / favorable opinion of the president’s party or party leaders in Congress")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0308"
    }
  }, [_vm._v("3.8")]), _vm._v("  Ratings of the president and president’s congressional parties performance as “excellent” or “pretty good” (Harris Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0309"
    }
  }, [_vm._v("3.9")]), _vm._v("  Approval of the president’s job performance and opinion of opposition party or party leaders in Congress")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0310"
    }
  }, [_vm._v("3.10")]), _vm._v("  Ratings of the president and opposition congressional party’s performance as “excellent” or “very good” (Harris Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0311"
    }
  }, [_vm._v("3.11")]), _vm._v("  Approval of the president’s job performance and approval of parties or party leaders in Congress, controlling for congressional approval")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0312"
    }
  }, [_vm._v("3.12")]), _vm._v("  Ratings of the president and congressional parties performance as “excellent” or “pretty good,” controlling for quarterly congressional approval (Harris Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0313"
    }
  }, [_vm._v("3.13")]), _vm._v("  Approval of the president’s job performance and approval of parties or party leaders in Congress, controlling for congressional approval, by control of the House, G. W. Bush and Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0314"
    }
  }, [_vm._v("3.14")]), _vm._v("  Effects of president’s thermometer ratings on party thermometer ratings, 1978–2016 (regression coefficients)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0315"
    }
  }, [_vm._v("3.15")]), _vm._v("  Relationships between party and president thermometer ratings over time")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#th0316"
    }
  }, [_vm._v("3.16")]), _vm._v("  Party thermometer ratings as a function of the president’s thermometer scores (Democracy Corps Polls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0401"
    }
  }, [_vm._v("4.1")]), _vm._v("  Presidential approval and perceptions of relative party competence")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0402"
    }
  }, [_vm._v("4.2")]), _vm._v("  Estimated effects of presidential approval on individual respondents’ perceptions of relative party superiority in handling the most important problem")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0403"
    }
  }, [_vm._v("4.3")]), _vm._v("  Presidential approval and the party more trusted to cope with the nation’s problems")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0404"
    }
  }, [_vm._v("4.4")]), _vm._v("  Presidential approval and preference for president or rival congressional party in handling national problems")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0405"
    }
  }, [_vm._v("4.5")]), _vm._v("  Approval of the president’s handling of the economy and party advantage on managing the economy")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0406"
    }
  }, [_vm._v("4.6")]), _vm._v("  President’s party’s advantage over rival party in Congress in trust on handling the economy as a function of approval of president’s performance on the economy")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0407"
    }
  }, [_vm._v("4.7")]), _vm._v("  The effects of presidential approval on education on relative party reputation for handling education")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0408"
    }
  }, [_vm._v("4.8")]), _vm._v("  Approval of the president’s handling of foreign policy and party advantage on managing foreign policy, Reagan through Obama administrations")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0409"
    }
  }, [_vm._v("4.9")]), _vm._v("  Approval of G. W. Bush’s handling of terrorism and the Republican Party advantage on dealing with it")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#th0410"
    }
  }, [_vm._v("4.10")]), _vm._v("  Approval of president’s job performance and opinion on which party is better for / cares more about “people like you” or “the middle class”")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0501"
    }
  }, [_vm._v("5.1")]), _vm._v("  ANES questions on ideology and policy positions from the cumulative data file")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0502"
    }
  }, [_vm._v("5.2")]), _vm._v("  Regression of mean locations of parties on locations of presidents / presidential candidates across election years")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0503"
    }
  }, [_vm._v("5.3")]), _vm._v("  Regression of mean locations of parties on locations of presidents / presidential candidates across election years, by party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0504"
    }
  }, [_vm._v("5.4")]), _vm._v("  Effects of president/candidate location on party location on the 7-point liberal–conservative scale (regression coefficients, individual surveys)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0505"
    }
  }, [_vm._v("5.5")]), _vm._v("  Effects of president/candidate location on party location on the 7-point issue scales (regression coefficients, individual surveys)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxi"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0506"
    }
  }, [_vm._v("5.6")]), _vm._v("  Changes in party location on ideology and issues scales as a function of changes in the president’s location (with controls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0507"
    }
  }, [_vm._v("5.7")]), _vm._v("  Coefficients from regressing party locations on presidents / presidential candidates and House candidates locations on the 7-point ideology and issue scales (with controls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0508"
    }
  }, [_vm._v("5.8")]), _vm._v("  Coefficients from regressing placement of Democratic Party on placement of Barack Obama and Democratic congressional candidates on the 7-point liberal–conservative scale, 2010–2014")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0509"
    }
  }, [_vm._v("5.9")]), _vm._v("  Coefficients from regressing placement of the Republican Party on placement of Mitt Romney on the 7-point liberal–conservative scale, 2012")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#th0510"
    }
  }, [_vm._v("5.10")]), _vm._v("  Coefficients from regressing placements of the parties on placement of the presidential candidates, Obama, and the House and Senate candidates on the 7-point liberal–conservative scale in 2016 (with controls)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#th0601"
    }
  }, [_vm._v("6.1")]), _vm._v("  The effects of presidential approval on changes in individual party identification")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#th0602"
    }
  }, [_vm._v("6.2")]), _vm._v("  The effects of presidential approval on changes in individual party identification (with lagged presidential approval)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#th0603"
    }
  }, [_vm._v("6.3")]), _vm._v("  Presidential approval and change in party identification between panel waves (weighted averages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#th0604"
    }
  }, [_vm._v("6.4")]), _vm._v("  Change in party identification as function of change in candidate affect, 2008–2009")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#th0605"
    }
  }, [_vm._v("6.5")]), _vm._v("  Presidential approval and macropartisanship")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#th0701"
    }
  }, [_vm._v("7.1")]), _vm._v("  Party identification of whites, 1952–2016 (percentages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#th0801"
    }
  }, [_vm._v("8.1")]), _vm._v("  Ticket splitting and party loyalty in presidential and state elections (percentages)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#th0802"
    }
  }, [_vm._v("8.2")]), _vm._v("  Net generic vote for president’s party’s candidate as a function of presidential approval")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#th0803"
    }
  }, [_vm._v("8.3")]), _vm._v("  Net preference for president’s party’s control of congress as a function of presidential approval")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#th0804"
    }
  }, [_vm._v("8.4")]), _vm._v("  Net number of House seats won or lost by the president’s party, 1946–2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#th0805"
    }
  }, [_vm._v("8.5")]), _vm._v("  Presidential approval and partisan voting in midterm elections, 1974–2014 (percent defecting to other party’s House candidate)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#th0901"
    }
  }, [_vm._v("9.1")]), _vm._v("  Polarized views of parties as a function of polarized views of the president")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#th0902"
    }
  }, [_vm._v("9.2")]), _vm._v("  Age, education, and the presidential vote in 2016 (percent voting for Trump)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#th0903"
    }
  }, [_vm._v("9.3")]), _vm._v("  Opinions of groups and policies in 2016")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#th0904"
    }
  }, [_vm._v("9.4")]), _vm._v("  Favorable opinion of the Republican Party as a function of Trump’s job approval (January 2017–April 2018)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74716853","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-jacobson-0007.vue
// module id = 72
// module chunks = 0